import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as MetalsIcon } from "../icons/Metals.svg";
import { ReactComponent as SoilIcon } from "../icons/Soil.svg?react";
import { ReactComponent as WoodIcon } from "../icons/Wood.svg?react";
import { ReactComponent as CementIcon } from "../icons/Cement.svg?react";
import { ReactComponent as RubberIcon } from "../icons/Rubber.svg?react";
import { ReactComponent as PlasticIcon } from "../icons/Plastic.svg?react";
import { ReactComponent as BricksIcon } from "../icons/Bricks.svg?react";
import { ReactComponent as ConcreteIcon } from "../icons/Concrete.svg?react";
import { ReactComponent as TilesIcon } from "../icons/Tiles.svg?react";
import { ReactComponent as CeramicsIcon } from "../icons/Ceramics.svg?react";
import { ReactComponent as WaterIcon } from "../icons/Water.svg?react";
import { ReactComponent as CoalIcon } from "../icons/Coal.svg?react";
import { ReactComponent as AluminiumIcon } from "../icons/Aluminium.svg?react";
import { ReactComponent as PVCIcon } from "../icons/PVC.svg?react";
import { ReactComponent as GlassIcon } from "../icons/Glass.svg?react";
import { ReactComponent as PaintIcon } from "../icons/Paint.svg?react";
import Chatbot from "./chatbot"; // Import the Chatbot component
import emailjs from "@emailjs/browser";
import { Helmet } from "react-helmet";

// Icon components
const XIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);
const CalendarCheckIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
    <line x1="16" x2="16" y1="2" y2="6" />
    <line x1="8" x2="8" y1="2" y2="6" />
    <line x1="3" x2="21" y1="10" y2="10" />
    <path d="m9 16 2 2 4-4" />
  </svg>
);
const ArrowRightIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M5 12h14" />
    <path d="m12 5 7 7-7 7" />
  </svg>
);
const FlaskConicalIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10 2v7.31" />
    <path d="M14 9.31V2" />
    <path d="M8.5 2h7" />
    <path d="M14 9.31c2.38.43 4.1 2.42 4.1 4.69 0 2.65-2.15 4.8-4.8 4.8H8.7c-2.65 0-4.8-2.15-4.8-4.8 0-2.27 1.72-4.26 4.1-4.69" />
    <path d="M7 14h10" />
  </svg>
);
const MenuIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="4" x2="20" y1="12" y2="12" />
    <line x1="4" x2="20" y1="6" y2="6" />
    <line x1="4" x2="20" y1="18" y2="18" />
  </svg>
);
const CheckCircleIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);
const GlobeIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);
const UsersIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);
const GiftIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 12 20 22 4 22 4 12" />
    <rect x="2" y="7" width="20" height="5" />
    <line x1="12" y1="22" x2="12" y2="7" />
    <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
    <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
  </svg>
);
const FileTextIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <line x1="10" y1="9" x2="8" y2="9" />
  </svg>
);
const ShieldIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);
const BadgeCheckIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3.85 8.62a4 4 0 0 1 4.78-4.78l.24.02a2 2 0 0 0 1.86-1.86l.02-.24a4 4 0 0 1 4.78-4.78l.24.02a2 2 0 0 0 1.86-1.86l.02-.24a4 4 0 0 1 4.78-4.78l-.02.24a2 2 0 0 0 1.86 1.86l-.24.02a4 4 0 0 1 4.78 4.78l-.02.24a2 2 0 0 0-1.86 1.86l.24.02a4 4 0 0 1-4.78 4.78l-.24-.02a2 2 0 0 0-1.86 1.86l-.02.24a4 4 0 0 1-4.78 4.78l-.24-.02a2 2 0 0 0-1.86 1.86l-.02.24a4 4 0 0 1-4.78 4.78l.02-.24a2 2 0 0 0-1.86-1.86l.24-.02a4 4 0 0 1-4.78-4.78l.02-.24a2 2 0 0 0 1.86-1.86z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);
const TwitterIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M22.46 6c-.77.35-1.6.58-2.46.67.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98-3.56-.18-6.73-1.89-8.84-4.48-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.22-1.95-.55v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21c7.35 0 11.37-6.08 11.37-11.37 0-.17 0-.34-.01-.51.78-.57 1.45-1.29 1.97-2.12z" />
  </svg>
);
const LinkedinIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M20.45 2h-16.9C2.67 2 2 2.67 2 3.55v16.9C2 21.33 2.67 22 3.55 22h16.9c.88 0 1.55-.67 1.55-1.55V3.55C22 2.67 21.33 2 20.45 2zM8.09 18.94h-3v-9.8h3v9.8zM6.59 7.7c-.97 0-1.75-.78-1.75-1.75S5.62 4.2 6.59 4.2c.97 0 1.75.78 1.75 1.75S7.56 7.7 6.59 7.7zm12.35 11.24h-3v-4.6c0-1.1-.02-2.5-1.52-2.5-1.53 0-1.76 1.19-1.76 2.42v4.68h-3v-9.8h2.88v1.32h.04c.4-.76 1.38-1.55 2.84-1.55 3.04 0 3.6 2 3.6 4.6v5.43z" />
  </svg>
);
const FacebookIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-1.5c-1 0-1 .5-1 1v2h3v-3h-3v6.95c5.05-.5 9-4.76 9-9.95z" />
  </svg>
);
const SettingsIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 0 2l-.15.08a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.38a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1 0-2l.15-.08a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
const RefreshCwIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 2v6h6" />
    <path d="M21 12A9 9 0 0 0 6 5.3L3 8" />
    <path d="M21 22v-6h-6" />
    <path d="M3 12a9 9 0 0 0 15 6.7l3-2.7" />
  </svg>
);
const BarChartIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="12" x2="12" y1="20" y2="10" />
    <line x1="18" x2="18" y1="20" y2="4" />
    <line x1="6" x2="6" y1="20" y2="16" />
  </svg>
);
const BookOpenIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
  </svg>
);

// Custom Hooks
const useScrollAnimation = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      },
      { threshold: 0.1 },
    );

    const elements = document.querySelectorAll(".scroll-animate");
    elements.forEach((el) => observer.observe(el));

    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);
};

// Header Component
const Header = ({ onScheduleDemoClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [isScrolled, setIsScrolled] = useState(false);
  const navLinks = ["About", "Features", "Why Pragya", "Tests", "Materials"];

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll, { passive: true });

    const sectionIds = [
      "home",
      ...navLinks.map((link) => link.toLowerCase().replace(" ", "-")),
    ];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { rootMargin: "-50% 0px -50% 0px" },
    );

    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      sectionIds.forEach((id) => {
        const el = document.getElementById(id);
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "pt-2" : "pt-4 sm:pt-6"
      }`}
    >
      <div className="  mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className={`flex items-center justify-between rounded-2xl transition-all duration-300 backdrop-blur-xl shadow-lg px-6 ${
            isScrolled ? "h-16 bg-white/80" : "h-20 bg-white/50"
          }`}
        >
          <a href="#home" className="flex items-center no-underline">
            <img src="/logo.svg" alt="Logo" />
          </a>
          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map((item) => {
              const linkId = item.toLowerCase().replace(" ", "-");
              return (
                <a
                  href={`#${linkId}`}
                  key={item}
                  className={`px-4 py-2 text-sm font-semibold rounded-full transition-colors no-underline ${
                    activeSection === linkId
                      ? "bg-blue-600 text-white"
                      : "text-gray-700 hover:bg-gray-200/70"
                  }`}
                >
                  {item}
                </a>
              );
            })}
          </nav>
          <div className="hidden lg:flex items-center">
            <button
              onClick={onScheduleDemoClick}
              className="bg-blue-800 text-white hover:bg-blue-700 px-5 py-2 rounded-full font-bold transition-transform transform hover:scale-105 shadow-md text-sm"
            >
              Schedule a Demo
            </button>
          </div>
          <div className="lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-800"
            >
              <MenuIcon className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>
      {isMenuOpen && (
        <div className="lg:hidden absolute top-full left-0 right-0 mx-4 mt-2 rounded-2xl bg-white shadow-xl p-6">
          <nav className="flex flex-col items-center space-y-4">
            {navLinks.map((item) => (
              <a
                href={`#${item.toLowerCase().replace(" ", "-")}`}
                key={item}
                onClick={() => setIsMenuOpen(false)}
                className="text-base font-semibold text-gray-800 hover:text-blue-900 no-underline"
              >
                {item}
              </a>
            ))}
            <button
              onClick={() => {
                onScheduleDemoClick();
                setIsMenuOpen(false);
              }}
              className="w-full bg-blue-800 text-white hover:bg-blue-700 px-6 py-3 rounded-full font-bold transition-transform transform hover:scale-105 shadow-lg mt-4"
            >
              Schedule a Demo
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

// Schedule Demo Modal
const ScheduleDemoModal = ({ isOpen, onClose }) => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs

      .sendForm(
        "service_ht9rk9y", // replace with your Service ID

        "template_grgypby", // replace with your Template ID

        form.current,

        "YBCHWzqOpr6TcXymc", // replace with your Public Key
      )

      .then(
        (result) => {
          console.log("Email sent:", result.text);

          alert("Email sent successfully!");

          onClose();
        },

        (error) => {
          console.error("Error:", error.text);

          alert("Failed to send email.");
        },
      );
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-gray-900/30 backdrop-blur-md z-[100] flex justify-center items-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 max-w-lg w-full relative animate-modalEnter max-h-[95vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Close modal"
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-800"
        >
          <XIcon className="w-6 h-6" />
        </button>
        <h2 className="text-2xl font-bold text-blue-900 mb-6 text-center">
          Schedule a Live Demo
        </h2>
        <form ref={form} onSubmit={sendEmail}>
          <div className="grid gap-1">
            <div>
              <label
                htmlFor="company"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Company Name
              </label>
              <input
                type="text"
                id="company"
                name="company"
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-800 focus:border-blue-800"
              />
            </div>
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-800 focus:border-blue-800"
              />
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-800 focus:border-blue-800"
              />
            </div>
            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Phone
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-800 focus:border-blue-800"
              />
            </div>
            <div>
              <label
                htmlFor="message"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                rows="3"
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-800 focus:border-blue-800"
              ></textarea>
            </div>
          </div>
          <button
            type="submit"
            className="w-full mt-6 bg-blue-900 text-white font-bold py-3 px-4 rounded-md shadow-lg transition-all transform hover:scale-105 disabled:bg-gray-400 disabled:cursor-not-allowed disabled:scale-100"
          >
            Request Demo
          </button>
        </form>
      </div>
    </div>
  );
};

function Home() {
  return (
    <div>
      <Helmet>
        <title>
          Pragyalims: Advanced LIMS Solutions for Testing Laboratories
        </title>
        <meta
          name="description"
          content="Pragyalims provides innovative LIMS software for testing labs, streamlining sample management, data analysis, and compliance. Optimize your laboratory workflows today."
        />
        <meta
          name="keywords"
          content="LIMS software, laboratory information management system, testing lab solutions, lab management software, sample management software, workflow automation LIMS, compliance management system, cloud-based LIMS, AI-driven lab analytics, ISO 17025 compliant LIMS, material testing labs, sample tracking, audit trail, barcode labeling, calibration management, electronic lab notebook, instrument interfacing, quality assurance, lab inventory management, automated report generation"
        />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="canonical" href="https://www.pragyalims.com/" />
        <meta property="og:title" content="Pragyalims: LIMS for Testing Labs" />
        <meta
          property="og:description"
          content="PragyaLIMS offers efficient Laboratory Information Management System for testing labs."
        />
        <meta property="og:image" content="%PUBLIC_URL%/hero.png" />
        <meta property="og:url" content="https://www.pragyalims.com/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Pragyalims LIMS Solutions" />
        <meta
          name="twitter:description"
          content="Advanced software for testing laboratories."
        />
        <meta name="twitter:image" content="%PUBLIC_URL%/hero.png" />
      </Helmet>
    </div>
  );
}

// Main App Component
export default function App() {
  useScrollAnimation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const featureTabs = [
    {
      category: "Configuration",
      icon: SettingsIcon,
      color: "text-blue-600 bg-blue-100",
      items: [
        "Users & Role Management",
        "Customer Management",
        "Test Management",
        "Reference Standards",
        "Test Rate Management",
        "Machine Maintenance",
        "Email Notifications",
      ],
    },
    {
      category: "Process",
      icon: RefreshCwIcon,
      color: "text-green-600 bg-green-100",
      items: [
        "Inward Workflow",
        "Inhouse & Outside Job work",
        "Testing & Approval",
        "Test Report Printing",
        "Dispatch Management",
        "Revise & Retest",
        "Amendment",
        "Test Cancellation",
        "Scanned Report Upload",
      ],
    },
    {
      category: "Ref. Standard & Test Method",
      icon: BookOpenIcon,
      color: "text-purple-600 bg-purple-100",
      items: [
        "ASME SA516:2021",
        "ASME SEC II:2021",
        "IS 5624:2021",
        "BS 970(P1):1991",
        "IS 2633:1986",
        "IS 269:2015",
        "AS 4699:2000",
        "BS 5975:2008",
        "ASTM E92:2017",
      ],
    },
    {
      category: "Reports",
      icon: BarChartIcon,
      color: "text-orange-600 bg-orange-100",
      items: [
        "Inward Register",
        "Process Status",
        "Dispatch Report",
        "Working Detail",
        "Inward vs Dispatch",
        "Pending Tests",
        "Test Details",
        "Invoice Detail",
        "Pending Invoices",
        "Customer Ledger",
        "Customer Outstanding",
      ],
    },
  ];

  const whyPragyaData = [
    {
      icon: GlobeIcon,
      title: "360° Digitization",
      description:
        "Access real-time data in one click. Manage, report, and identify data instantly, with fewer efforts.",
    },
    {
      icon: UsersIcon,
      title: "Anybody can LIMS",
      description:
        "Our adaptable interface makes it easy for any team member to operate without special skills or certification.",
    },
    {
      icon: GiftIcon,
      title: "Integrated Incentive Module",
      description:
        "A unique module that rewards team members with incentives for each task, speeding up processes.",
    },
    {
      icon: FileTextIcon,
      title: "Smart Report Summaries",
      description:
        "Records all data to summarize into smart reports. View, print, or download in desired formats.",
    },
    {
      icon: ShieldIcon,
      title: "Stringent Authentication",
      description:
        "Smooth to operate with stringent authentication, ensuring data remains secure until approved.",
    },
    {
      icon: BadgeCheckIcon,
      title: "Abides To Government Standards",
      description:
        "Configured to abide by Government Standards, including registered Test References and QR Scanning.",
    },
  ];

  const limsFeatures = [
    "Sample management",
    "Quotation & Invoicing",
    "Workflow management",
    "Lab Execution System",
    "Quality Assurance",
    "Inventory Management",
    "Instrumentation",
    "Tests",
    "Documentation",
    "Electronic Lab Notebook",
    "Reporting & Certificates",
    "Stability Studies",
  ];

  const testingMaterials = [
    { name: "Metals", icon: MetalsIcon },
    { name: "Soil", icon: SoilIcon },
    { name: "Wood", icon: WoodIcon },
    { name: "Cement", icon: CementIcon },
    { name: "Rubber", icon: RubberIcon },
    { name: "Plastic", icon: PlasticIcon },
    { name: "Bricks", icon: BricksIcon },
    { name: "Concrete", icon: ConcreteIcon },
    { name: "Tiles", icon: TilesIcon },
    { name: "Ceramics", icon: CeramicsIcon },
    { name: "Water", icon: WaterIcon },
    { name: "Coal", icon: CoalIcon },
    { name: "Aluminium", icon: AluminiumIcon },
    { name: "PVC", icon: PVCIcon },
    { name: "Glass", icon: GlassIcon },
    { name: "Paint", icon: PaintIcon },
  ];

  const aboutTests = [
    "Spectro Chemical",
    "Tensile Test",
    "Viscosity by stormer",
    "Hardness Test",
    "Rockwell Hardness Test",
    "Bend Test",
    "Salt Spray Test",
    "Dry Film Thickness",
  ];

  return (
    <div className="bg-white font-sans antialiased text-gray-800">
      <style>{`
        html { scroll-behavior: smooth; }
        @keyframes modalEnter { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-modalEnter { animation: modalEnter 0.3s ease-out forwards; }
        
        .blob { position: absolute; border-radius: 50%; filter: blur(50px); opacity: 0.3; z-index: 0; }
        .blob-1 { width: 350px; height: 350px; top: -80px; left: -120px; background-color: #a3bffa; animation: blob-move 15s infinite ease-in-out; }
        .blob-2 { width: 450px; height: 450px; bottom: -120px; right: -180px; background-color: #c084fc; animation: blob-move 20s infinite ease-in-out reverse; }
        @keyframes blob-move { 0%, 100% { transform: translate(0, 0) scale(1); } 25% { transform: translate(40px, -60px) scale(1.1); } 50% { transform: translate(10px, 20px) scale(0.9); } 75% { transform: translate(-30px, 50px) scale(1.05); } }

        .scroll-animate {
            transition: opacity 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275), transform 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            transition-delay: var(--scroll-delay, 0s);
        }
        .scroll-animate:not(.is-visible) { opacity: 0; }
        .scroll-animate.fade-in-up:not(.is-visible) { transform: translateY(40px); }
        .scroll-animate.fade-in-down:not(.is-visible) { transform: translateY(-40px); }
        .scroll-animate.fade-in-left:not(.is-visible) { transform: translateX(-40px); }
        .scroll-animate.fade-in-right:not(.is-visible) { transform: translateX(40px); }
        .scroll-animate.zoom-in:not(.is-visible) { transform: scale(0.9); }
        .scroll-animate.is-visible { opacity: 1; transform: translate(0, 0) scale(1); }

        .custom-scrollbar::-webkit-scrollbar { width: 5px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 10px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #ccc; border-radius: 10px; }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #aaa; }

        @keyframes pulseGlow {
            0%, 100% { box-shadow: 0 0 10px rgba(59, 130, 246, 0.4); }
            50% { box-shadow: 0 0 20px rgba(59, 130, 246, 0.7); }
        }
        .pulse-glow { animation: pulseGlow 2s ease-in-out infinite; }

        .test-card {
            background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
            border-radius: 1rem;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .test-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
        }

        @keyframes rotateGlow {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .rotate-glow { animation: rotateGlow 20s linear infinite; }
      `}</style>

      <Header onScheduleDemoClick={() => setIsModalOpen(true)} />
      <ScheduleDemoModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
      <div className="chatbot">
        <Chatbot />
      </div>
      <main className="overflow-x-hidden">
        {/* Hero Section */}
        <section
          id="home"
          className="bg-[#f0f4f9] min-h-screen flex items-center justify-center overflow-hidden relative pt-24 pb-12"
        >
          <div className="blob blob-1"></div>
          <div className="blob blob-2"></div>
          <div className="px-4 sm:px-6 lg:px-8 w-full z-10">
            <div className="grid md:grid-cols-2 gap-x-12  items-center">
              <div className="text-center md:text-left home-section">
                <h1 className="scroll-animate fade-in-right text-4xl md:text-5xl lg:text-[3.5rem] leading-tight font-extrabold tracking-tight">
                  <span className="text-gray-500">PRAGYA</span>{" "}
                  <span className="text-[#18A594]">LIMS</span>
                </h1>

                <p
                  className="scroll-animate fade-in-right mt-6 text-lg md:text-xl text-gray-600 max-w-xl mx-auto md:mx-0"
                  style={{ "--scroll-delay": "150ms" }}
                >
                  Transform your laboratory with our AI-powered
                  LIMS—streamlining operations with precision sample tracking,
                  seamless integrations, and robust compliance tools.
                </p>
                <div
                  className="scroll-animate fade-in-right mt-10 flex flex-col sm:flex-row gap-4 justify-self-center justify-center md:justify-start"
                  style={{ "--scroll-delay": "300ms" }}
                >
                  <button
                    onClick={() => setIsModalOpen(true)}
                    className="inline-flex items-center justify-center px-7 py-3 bg-blue-700 hover:bg-blue-600 text-white rounded-full font-semibold shadow-lg transition-transform transform hover:scale-105"
                  >
                    <CalendarCheckIcon className="w-5 h-5 mr-2" />
                    Schedule Demo
                  </button>
                  <a
                    href="#features"
                    className="inline-flex items-center justify-center px-7 py-3 border-2 border-gray-300 text-gray-700 rounded-full font-semibold transition-colors hover:bg-gray-200 no-underline"
                  >
                    Explore Features
                    <ArrowRightIcon className="w-5 h-5 ml-2" />
                  </a>
                </div>
              </div>
              <div className="scroll-animate fade-in-left relative flex items-center justify-center h-[400px] md:h-[500px] m-10 mt-0">
                <div className="w-full max-w-xl mx-auto">
                  <div className="relative aspect-[16/10] bg-gray-100 rounded-t-xl border-x-2 border-t-2 border-gray-800 p-1">
                    <div className="absolute top-1.5 left-1/2 -translate-x-1/2 w-1.5 h-1.5 bg-gray-600 rounded-full"></div>
                    <div className="bg-black rounded-lg overflow-hidden h-full">
                      <img
                        src="/dashbord_pc.png"
                        alt="Desktop Product Screenshot"
                        className="w-full h-full "
                      />
                    </div>
                  </div>
                  <div className="h-4 bg-gradient-to-r from-gray-700 to-gray-900 rounded-b-xl"></div>
                  <div className="w-3 h-8 bg-gray-400 mx-auto"></div>
                  <div className="h-1.5 w-36 mx-auto bg-gradient-to-r from-gray-300 to-gray-400 rounded-t-md shadow-2xl"></div>
                </div>
                {/* <div className="w-full "> */}
                <div className="max-w-xl mx-auto absolute -bottom-8 -right-4 w-32 h-64 md:w-48 md:h-[26rem] bg-gray-900 rounded-3xl border-2 border-gray-700 shadow-2xl z-10">
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-11 h-2.5 bg-gray-900 rounded-b-lg z-20"></div>
                  <img
                    src="/dashbord_mobile123.svg"
                    alt="Mobile Product Screenshot"
                    className="w-full h-full rounded-[22px]"
                  />
                </div>

                {/* </div> */}
              </div>
            </div>
          </div>
        </section>

        {/* About LIMS Section */}
        <section
          id="about"
          className="py-24 bg-gradient-to-br from-blue-50 via-white to-purple-50 relative overflow-hidden"
        >
          <div className="absolute inset-0 opacity-10 pointer-events-none">
            <div className="absolute w-96 h-96 bg-blue-200 rounded-full -top-48 -left-48 blur-3xl"></div>
            <div className="absolute w-96 h-96 bg-purple-200 rounded-full -bottom-48 -right-48 blur-3xl"></div>
          </div>
          <div className="m-1 px-4 sm:px-6 lg:px-8 relative z-10">
            <div className="text-center mb-16 scroll-animate fade-in-down">
              <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                Discover Pragya LIMS
              </h2>
              <p className="titleHeading mt-2 text-4xl leading-12 font-extrabold tracking-tight text-gray-900 sm:text-5xl bg-clip-text text-transparent bg-gradient-to-r from-blue-700 to-purple-600 mb-4">
                Empowering Labs with Precision
              </p>
              <p className="mt-4 max-w-3xl text-xl text-gray-600 mx-auto">
                Pragya LIMS redefines laboratory management with a cutting-edge,
                AI-driven solution tailored for all testing needs.
              </p>
            </div>
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="scroll-animate fade-in-left space-y-6">
                <div className="bg-white p-8 rounded-2xl shadow-xl pulse-glow">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    A Future-Ready Solution
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    Pragya LIMS is a versatile, web-based platform designed for
                    material testing labs of all sizes. Compliant with global
                    standards, it automates workflows, streamlines processes,
                    and ensures precision in every test.
                  </p>
                </div>
                <div className="bg-white p-8 rounded-2xl shadow-xl pulse-glow">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    Built for Scalability
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    From small startups to large-scale laboratories, Pragya LIMS
                    adapts to your needs, offering seamless integration and
                    real-time data access for unmatched efficiency.
                  </p>
                </div>
              </div>
              <div className="scroll-animate fade-in-right relative">
                <div className="relative bg-gradient-to-br from-blue-100 to-purple-100 p-6 rounded-2xl shadow-2xl">
                  <div className="absolute -top-4 -left-4 w-12 h-12 bg-blue-500 rounded-full opacity-50 animate-pulse"></div>
                  <div className="absolute -bottom-4 -right-4 w-12 h-12 bg-purple-500 rounded-full opacity-50 animate-pulse"></div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">
                    Supported Tests
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {aboutTests.map((test, index) => (
                      <div
                        key={test}
                        className="test-card p-4 flex items-center space-x-3"
                      >
                        <CheckCircleIcon className="w-6 h-6 text-green-500 flex-shrink-0" />
                        <span className="text-gray-700 font-medium">
                          {test}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section id="features" className="py-24 bg-white">
          <div className="m-1 px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16 scroll-animate fade-in-down">
              <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                Intelligent by Design
              </h2>
              <p className="titleHeading mt-2 text-4xl leading-12 font-extrabold tracking-tight text-gray-900 sm:text-5xl bg-clip-text text-transparent bg-gradient-to-r from-blue-700 to-purple-600 mb-4">
                Engineered for the Modern Laboratory
              </p>
              <p className="mt-4 max-w-3xl text-xl text-gray-500 mx-auto">
                Explore a suite of powerful, purpose-built features that
                digitize every aspect of your lab's workflow, from sample intake
                to final reporting.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {featureTabs.map((tab, index) => (
                <div
                  key={tab.category}
                  className="scroll-animate fade-in-up bg-white p-6 rounded-2xl shadow-xl border border-gray-200 transition-all duration-300 hover:shadow-2xl hover:border-blue-300 flex flex-col"
                  style={{ "--scroll-delay": `${index * 100}ms` }}
                >
                  <div className="flex-shrink-0">
                    <div
                      className={`w-14 h-14 rounded-full flex items-center justify-center ${tab.color} mb-5 shadow-md`}
                    >
                      <tab.icon className="w-8 h-8" />
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-4">
                      {tab.category}
                    </h3>
                  </div>
                  <div className="flex-grow overflow-y-auto pr-2 custom-scrollbar">
                    <div className="space-y-3">
                      {tab.items.map((item) => (
                        <div key={item} className="flex items-start">
                          <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5 mr-2" />
                          <span className="text-gray-600 text-sm">{item}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Pragya LIMS Section */}
        <section
          id="why-pragya"
          className="py-24 bg-gray-50 relative overflow-hidden"
        >
          <div className="m-1 px-4 sm:px-6 lg:px-8 relative z-10">
            <div className="text-center scroll-animate fade-in-down">
              <h2 className="text-base text-purple-600 font-semibold tracking-wide uppercase">
                The Pragya Difference
              </h2>
              <p className="titleHeading mt-2 text-4xl leading-12 font-extrabold tracking-tight text-gray-900 sm:text-5xl bg-clip-text text-transparent bg-gradient-to-r from-blue-700 to-purple-600 mb-4">
                Unlock Unprecedented Efficiency
              </p>
              <p className="mt-4 max-w-3xl text-xl text-gray-500 mx-auto">
                Discover why leading laboratories trust Pragya LIMS to enhance
                productivity, ensure compliance, and drive data-driven
                decisions.
              </p>
            </div>
            <div className="mt-16 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
              {whyPragyaData.map((item, index) => (
                <div
                  key={item.title}
                  className="scroll-animate zoom-in bg-white p-8 rounded-2xl shadow-xl transition-all duration-300 hover:shadow-2xl hover:-translate-y-2"
                  style={{ "--scroll-delay": `${index * 100}ms` }}
                >
                  <div className="bg-blue-100 text-blue-700 rounded-full h-12 w-12 flex items-center justify-center">
                    <item.icon className="w-6 h-6" />
                  </div>
                  <h3 className="mt-6 text-xl font-bold text-gray-900">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-base text-gray-600">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Explore how a LIMS helps you Section */}
        <section
          id="tests"
          className="py-12 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden"
        >
          <div className="px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto">
            <div className="text-center mb-8 scroll-animate fade-in-down">
              <h2 className="text-base text-indigo-600 font-semibold tracking-wide uppercase">
                Lab Transformation
              </h2>
              <p className="titleHeading mt-2 text-4xl leading-12 font-extrabold tracking-tight text-gray-900 sm:text-5xl bg-clip-text text-transparent bg-gradient-to-r from-indigo-700 to-blue-600">
                Elevate Your Lab’s Potential
              </p>
              <p className="mt-2 max-w-xl text-sm text-gray-600 mx-auto">
                Unleash efficiency and precision with our cutting-edge LIMS
                features, designed for modern labs.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {[
                { name: "Sample Management", icon: FlaskConicalIcon },
                { name: "Quotation & Invoicing", icon: FileTextIcon },
                { name: "Workflow Management", icon: RefreshCwIcon },
                { name: "Lab Execution System", icon: SettingsIcon },
                { name: "Quality Assurance", icon: BadgeCheckIcon },
                { name: "Inventory Management", icon: CheckCircleIcon },
                { name: "Instrumentation", icon: FlaskConicalIcon },
                { name: "Tests", icon: FlaskConicalIcon },
                { name: "Documentation", icon: FileTextIcon },
                { name: "Electronic Lab Notebook", icon: BookOpenIcon },
                { name: "Reporting & Certificates", icon: BarChartIcon },
                { name: "Stability Studies", icon: ShieldIcon },
              ].map((feature, index) => (
                <div
                  key={feature.name}
                  className="scroll-animate fade-in-up bg-white p-4 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 relative group overflow-hidden"
                  style={{ "--scroll-delay": `${index * 60}ms` }}
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-indigo-50 to-blue-50 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
                  <div className="relative flex items-center">
                    <div className="flex-shrink-0 w-8 h-8 bg-indigo-100 rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
                      <feature.icon className="w-5 h-5 text-indigo-600" />
                    </div>
                    <h3 className="ml-3 text-base font-semibold text-gray-900 group-hover:text-indigo-700 transition-colors duration-300">
                      {feature.name}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <style>{`
    @keyframes subtlePulse {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.02); }
    }
    .group:hover .bg-indigo-100 {
      animation: subtlePulse 1.5s ease-in-out infinite;
    }
  `}</style>
        </section>

        {/* Testing Materials Section */}
        <section id="materials" className="py-24 bg-gray-50">
          <div className="m-1 px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16 scroll-animate fade-in-down">
              <h2 className="text-base text-purple-600 font-semibold tracking-wide uppercase">
                Universal Material Compatibility
              </h2>
              <p className="titleHeading mt-2 text-4xl leading-12 font-extrabold tracking-tight text-gray-900 sm:text-5xl bg-clip-text text-transparent bg-gradient-to-r from-blue-700 to-purple-600 mb-7">
                Analyze Any Sample, Any Time
              </p>
              <p className="mt-6 max-w-3xl text-xl text-gray-500 mx-auto">
                From raw materials to finished products, our platform is
                engineered to manage testing for a comprehensive spectrum of
                material types.
              </p>
            </div>
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-8 gap-6 text-center">
              {testingMaterials.map((material, index) => (
                <div
                  key={material.name}
                  className="scroll-animate zoom-in flex flex-col items-center"
                  style={{ "--scroll-delay": `${index * 50}ms` }}
                >
                  <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300">
                    <material.icon className="w-10 h-10 text-gray-600" />
                  </div>
                  <p className="mt-4 font-semibold text-gray-700">
                    {material.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-gray-900 text-gray-300">
          <div className="m-1 mb-0 py-8 px-4 sm:px-6 lg:px-8">
            {/* Using a 4-column grid to space out content and move social icons to the right */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {/* Column 1: Brand Info */}
              <div className="space-y-4">
                <a
                  href="#home"
                  className="inline-flex items-center space-x-2 text-white text-xl font-bold no-underline"
                >
                  <img src="/logo_white.svg" alt="Logo" />
                </a>
                <p className="text-gray-400 text-sm">
                  Empowering modern laboratories with intelligent, streamlined
                  data management solutions.
                </p>
              </div>

              {/* Column 2: Quick Links */}
              <div>
                <h3 className="text-sm font-semibold text-gray-200 tracking-wider uppercase">
                  Quick Links
                </h3>
                <ul className="mt-4 space-y-3">
                  <li>
                    <a
                      href="#about"
                      className="text-gray-400 hover:text-white transition text-sm no-underline"
                    >
                      About Us
                    </a>
                  </li>
                  <li>
                    <a
                      href="#features"
                      className="text-gray-400 hover:text-white transition text-sm no-underline"
                    >
                      Features
                    </a>
                  </li>
                  <li>
                    <a
                      href="#why-pragya"
                      className="text-gray-400 hover:text-white transition text-sm no-underline"
                    >
                      Why Pragya
                    </a>
                  </li>
                  <li>
                    <a
                      href="#tests"
                      className="text-gray-400 hover:text-white transition text-sm no-underline"
                    >
                      Tests
                    </a>
                  </li>
                </ul>
              </div>

              {/* Column 3: Contact Us */}
              <div>
                <h3 className="text-sm font-semibold text-gray-200 tracking-wider uppercase">
                  Contact Us
                </h3>
                <ul className="mt-4 space-y-3 text-sm text-gray-400">
                  <li className="flex items-start">
                    <span className="font-semibold mr-2 shrink-0">Email:</span>
                    <a
                      href="mailto:info@pragyalims.com"
                      className="hover:text-white transition no-underline break-all"
                    >
                      info@pragyalims.com
                    </a>
                  </li>
                  <li className="flex items-start">
                    <span className="font-semibold mr-2 shrink-0">Phone:</span>
                    <a
                      href="tel:+1234567890"
                      className="hover:text-white transition no-underline"
                    >
                      +91 94289 58799
                    </a>
                  </li>
                </ul>
              </div>

              {/* Column 4: Social Icons (Right-aligned on large screens) */}
              <div className="lg:justify-self-end">
                <h3 className="text-sm font-semibold text-gray-200 tracking-wider uppercase">
                  Follow Us
                </h3>
                <div className="flex space-x-4 pt-4 lg:justify-end">
                  <a
                    href="#"
                    aria-label="Twitter"
                    className="text-gray-400 hover:text-white transition"
                  >
                    {/* Replace with your actual icon component */}
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.71v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                    </svg>
                  </a>
                  <a
                    href="https://in.linkedin.com/company/pragya-lims"
                    aria-label="LinkedIn"
                    className="text-gray-400 hover:text-white transition"
                  >
                    {/* Replace with your actual icon component */}
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </a>
                  <a
                    href="#"
                    aria-label="Facebook"
                    className="text-gray-400 hover:text-white transition"
                  >
                    {/* Replace with your actual icon component */}
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>

            {/* Updated Copyright section */}
            <div className="mt-8 border-t border-gray-700 pt-6 text-center">
              <p className="text-sm text-gray-400">
                ©All rights reserved Pragya LIMS 2025 | Developed by{" "}
                <a
                  href="https://www.appegic.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-semibold text-gray-300 hover:text-white transition-colors"
                >
                  Appegic.
                </a>
              </p>
            </div>
          </div>
        </footer>
      </main>
    </div>
  );
}
